<ion-header>
    <ion-toolbar color="header">
      <ion-title class="ion-text-wrap">{{'AppSettings' | translate}}</ion-title>
      <ion-button  fill="clear" slot="end" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-header>
  
  <ion-content class="in-background">
    <ion-card>
      <ion-list>
        <ion-item lines="none">
          <ion-label>{{'Language' | translate}}</ion-label>
          <ion-select (ionChange)="setLanguage($event)" interface="popover" [(ngModel)]="userLanguage" cancelText="{{'Cancel' | translate}}">
            <ion-select-option *ngFor="let lang of languages" [value]="lang.code">{{lang.name}}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item lines="none">
          <ion-label>{{'Theme' | translate}}</ion-label>
          <ion-select (ionChange)="changeTheme($event)" interface="popover" [(ngModel)]="theme" cancelText="{{'Cancel' | translate}}">
            <ion-select-option *ngFor="let t of themes" [value]="t.value">{{t.label | translate}}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-card>
  </ion-content>